import styled from "styled-components";
import * as mq from "../../styles/mediaQueries";

export const FooterMain = styled.div`
  color: #fff;
  font-size: 1rem;
  background-color: #1e2aa8;
`;

export const CopyrightImg = styled.img`
  width: 50%;
  ${mq.sm} {
    width: 70%;
  }
  ${mq.xs} {
    width: 100%;
  }
  padding: 18px 4px 0px;
`;

export const FooterData = styled.div`
  text-align: center;
  font-size: 0.7rem;
  ${mq.sm} {
    font-size: 0.5rem;
  }
`;
